import { getAllTemplate } from 'src/redux/actions/templateAction'
import {
  GET_ALL_REPORT_DETAILS,
  GET_ONE_REPORT_DETAILS,
  GET_ONE_REPORT_ID_NULL,
  GET_ALL_REPORT_DETAILS_FILE_LISTING,
  GET_TEMPLATE_PDF
} from '../../types'

const INITIAL_STATE = {
  allRegulatoryReport: [],
  allRegulatoryReportFileLISting: [],
  // oneRegReport: {},
  oneRegReport: {
    regReportId: null,
    // other properties
  },
  getAllTemplate: []

}

const regulatoryReportReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_REPORT_DETAILS:
      return {
        ...state,
        allRegulatoryReport: payload,
      }

    case GET_ALL_REPORT_DETAILS_FILE_LISTING:
      return {
        ...state,
        allRegulatoryReportFileLISting: payload.data,
      }

    case GET_ONE_REPORT_DETAILS:
      return {
        ...state,
        oneRegReport: payload.data,
      }
    case GET_ONE_REPORT_ID_NULL:
      return {
        ...state,
        oneRegReport: {
          ...state.oneRegReport,
          regReportId: null,
        },
      }
      case GET_TEMPLATE_PDF:
      return {
        ...state,
        getAllTemplate: payload.data,
      }

    default:
      return state
  }
}

export default regulatoryReportReducer
